import {Formik} from 'formik'
import Input from '../../components/core/input'
import text from './text.json'
import {SimpleBlueButton} from '../../components/core/button'
import ButtonLoader from '../../components/core/button/ButtonLoader'
import {useMemo, useState} from 'react'
import {addTeamSchema} from '../../utils/validation'
import {useDispatch} from 'react-redux'
import {addTeam, updateTeam} from '../../stores/teams'
import LimitManager from '../../utils/limitManager'
import {handleFormChanges} from '../../utils/forms'
import localStorageKeys from '../../utils/localStorageKeys'
import RenderedForPaid from '../../components/pages/RenderedForPaid'
import {calculateRemaining} from '../../utils/limits'
import plans from '../../data/plans.json'
import TextHelper from '../../utils/text'

const TeamForm = ({closeModal, team, teamLength, modal}) => {
    const [buttonIsDisabled, setButtonIsDisabled] = useState(true)
    const [loader, setLoader] = useState(false)
    const [activeInfo, setActiveInfo] = useState(null)
    const currentPlan = localStorage.getItem(localStorageKeys.PLAN)
    const teamLimit = useMemo(() => LimitManager.getTeamLimit(), [])
    const isExceeded = Number(LimitManager.getTeamLimit()) === teamLength

    const dispatch = useDispatch()

    const names = {
        name: 'name'
    }
    const initialFormValues = {
        [names.name]: modal?.isEdit ? team?.name : ''
    }
    const submitForm = async(values, {setFieldError}) => {
        setLoader(true)
        const success = await dispatch(team?.team_id ? updateTeam(team?.team_id, values, setFieldError) : addTeam(values, setFieldError))
        setLoader(false)
        if (success) {
            closeModal()
        }
    }

    const handleInfo = (index, state) => {
        state ? setActiveInfo(index) : setActiveInfo(null)
    }

    const getPaidText = calculateRemaining(teamLimit, teamLength) > 0 && TextHelper.replaceAllChars(
        TextHelper.replaceAllChars(
            text.for_paid,
            ':team_count',
            calculateRemaining(teamLimit, teamLength)
        ),
        ':team_limit',
        teamLimit
    )

    const isDisabled = !modal?.isEdit && isExceeded || currentPlan === plans.free_v2.key

    return (
        <Formik
            enableReinitialize={true}
            initialValues={initialFormValues}
            onSubmit={submitForm}
            validationSchema={addTeamSchema}
            validateOnBlur={false}
            validateOnChange={false}
        >

            {({values, errors, handleChange, handleSubmit, setFieldValue}) => (
                <form onSubmit={handleSubmit} className="modal-body">
                    {!modal?.isEdit &&
                        <RenderedForPaid
                            forPaidText={getPaidText || text.for_paid_general}
                            isExceeded={isExceeded}
                            isTextWithLimits={!!getPaidText}/>
                    }
                    <Input
                        type="text"
                        value={values[names.name]}
                        onChange={e => {
                            setButtonIsDisabled(handleFormChanges(e, names.name, setFieldValue, initialFormValues))
                        }}
                        placeholder={text.name}
                        name={names.name}
                        error={errors[names.name]}
                        inputIsDisabled={isDisabled}
                        infoText={text.name_info}
                        activeInfo={activeInfo === names.name}
                        handleInfo={(state) => handleInfo(names.name, state)}/>
                    <SimpleBlueButton type="submit"
                        disabled={loader || (modal?.isEdit && buttonIsDisabled) || isDisabled}>
                        {loader && <ButtonLoader/>}
                        {text.submit}
                    </SimpleBlueButton>
                </form>
            )}
        </Formik>
    )
}

export default TeamForm
